export default defineI18nConfig(() => ({
  legacy: true,
  locale: "ru",
  fallbackLocale: 'ru',
}));
